import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setIsFullOptionsShown', function setIsFullOptionsShown(newValue) {
    getStore().isFullOptionsShown = newValue;
});
//# sourceMappingURL=setIsFullOptionsShown.js.map